<template>
  <footer id="footer_main">
    <div id="footer_main__inner">
      <section>
        <Header first h2 grey>Business details</Header>
        <Paragraph last :class="'footer__paragraph'">
          <SemiBold>Ing. Michal Ševčík</SemiBold><br />
          IČ / Company ID: <SemiBold>87539187</SemiBold><br />
          DIČ / VAT ID: <SemiBold>CZ9002124208</SemiBold>
        </Paragraph>
      </section>
      <section>
        <Header first h2 grey>Contact</Header>
        <Paragraph last :class="'footer__paragraph'">
          Phone: <SemiBold>+420 774 816 922</SemiBold><br />
          E-mail:
          <SemiBold
            ><EmailLink href="mailto:sevcik.mi@gmail.com"
              >sevcik.mi@gmail.com</EmailLink
            ></SemiBold
          >
        </Paragraph>
      </section>
      <section>
        <Header first h2 grey>Socials</Header>
        <Paragraph last :class="'footer__paragraph'">
          <a href="https://www.linkedin.com/in/michal-sevcik/" target="_blank"
            ><LinkedInIcon
              width="25"
              style="margin-right: 10px; color: #0e76a8;"
              class="social-icon"
          /></a>
          <a href="https://twitter.com/melkornms" target="_blank">
            <TwitterIcon
              width="25"
              style="color: #38A1F3; margin-right: 10px; "
              class="social-icon"
          /></a>
          <a href="https://github.com/MelkorNemesis" target="_blank">
            <GithubIcon width="25" style="color: #000;" class="social-icon" />
          </a>
        </Paragraph>
      </section>
    </div>
  </footer>
</template>

<script>
import { Header, Paragraph, SemiBold, Link, LinkedInIcon, GithubIcon } from ".";
import TwitterIcon from "./TwitterIcon";

export default {
  name: "Footer",
  components: {
    TwitterIcon,
    LinkedInIcon,
    GithubIcon,
    Header,
    EmailLink: Link,
    Paragraph,
    SemiBold
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

#footer_main {
  padding: 40px $spacing4;
  display: flex;
  justify-content: center;

  background: #fbfafb;
}

#footer_main__inner {
  max-width: 960px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: $sm-up) {
    flex-wrap: nowrap;
  }

  section {
    width: 100%;
    text-align: center;

    & + section {
      margin-top: 30px;
    }

    @media (min-width: $sm-up) {
      width: auto;
      text-align: left;

      & + section {
        margin-top: 0;
        margin-left: 80px;
      }
    }

    color: #525252;

    .Paragraph {
      line-height: 2;
      font-size: small;
    }
  }
}

.social-icon {
  transition: transform 0.3s;
}

.social-icon:hover {
  transform: rotate(-7deg);
}
</style>
